import { Box, Typography, Button } from '@mui/material';
import React from 'react';
import TextField from '@mui/material/TextField';
import modalstyles from './ModalComponent.module.css';
import Backdrop from '@mui/material/Backdrop';
import { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Image } from 'cloudinary-react'

import axios from 'axios';
// import { Image } from 'cloudinary-react';
import { MuiOtpInput } from 'mui-one-time-password-input'
import { useSelector, useDispatch } from 'react-redux';
import { Update } from '@mui/icons-material';
import  {setUserDetails}  from './../.././state/GlobalState'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 304,
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: 0,
  p: 4,

};

const style1 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 304,
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: 0,
  p: 4,

};




const ModalComponent = ({ handleCloseParent,data }) => {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [passOpen, setPassOpen] = React.useState(false);
  const handlePassOpen = () => setPassOpen(true);
  const handlePassClose = () => setPassOpen(false);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleMobileOpen = () => setMobileOpen(true);
  const handleMobileClose = () => setMobileOpen(false);

  const [verifyOpen, setVerifyOpen] = useState(false);
  const handleVerifyOpen = () => setVerifyOpen(true);
  const handleVerifyClose = () => setVerifyOpen(false);

  const [verifyMobileOpen, setVerifyMobileOpen] = useState(false);
  const handleVerifyMobileOpen = () => setVerifyMobileOpen(true);
  const handleVerifyMobileClose = () => setVerifyMobileOpen(false);

  const [verifyNewMobileOpen, setVerifyNewMobileOpen] = useState(false);
  const handleVerifyNewMobileOpen = () => setVerifyNewMobileOpen(true);
  const handleVerifyNewMobileClose = () => setVerifyNewMobileOpen(false);

  const [requestOtpOpen, setRequestOtpOpen] = React.useState(false);
  const handleRequestOtpOpen = () => setRequestOtpOpen(true);
  const handleRequestClose = () => setRequestOtpOpen(false);
  // ******************Email verifying********************** 
  const [requestEmailOpen, setRequestEmailOpen] = React.useState(false);
  const handleRequestEmailOpen = () => setRequestEmailOpen(true);
  const handleRequestEmailClose = () => setRequestEmailOpen(false);

  // ******************Email verifying********************** 

  const [submitOpen, setSubmitOpen] = useState(false);
  const handleSubmitOpen = () => setSubmitOpen(true);
  const handleSubmitClose = () => setSubmitOpen(false);



  const [newModalOpen, setNewModalOpen] = useState(false);
  const handleNewModalOpen = () => setNewModalOpen(true);
  const handleNewModalClose = () => setNewModalOpen(false);


  const handleSubmitOpens = () => {
    setSubmitOpen(false); // Close the previous modal
    handleNewModalOpen(); // Open the new modal
  };
  // ************************** New Added Start****************** 
  const userDetailState = useSelector((state) => state.globalData.userDetails);
  const count = useSelector((state) => state.globalData.notificationCount);
  const dispatch = useDispatch();

  const [UpdatePhone, setUpdatePhone] = useState("");
  const [isApiSuccess, setApiSuccess] = useState(false);

  const token = useSelector((state) => state.globalData.token);
  const userDetails = useSelector((state) => state.globalData.userDetails);

  const handleKeyPress = (e) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);

    const validInput = /^[0-9\b]+$/.test(keyValue);

    if (!validInput) {
      e.preventDefault();
    }
  };
  const [businessData, setBusinessData] = useState({
    phoneNumber: userDetails.phoneNumber || "",
    email: userDetails.email || "",
    id: userDetails.id || "",
  });
  const [userData, setUserData] = useState("");
  const [otp, setOtp] = useState("")
  const [emailOtp, setEmailOtp] = useState("")

  useEffect(() => {
    if (data) {
      setBusinessData({
        phoneNumber: data.userDetail.phoneNumber,
        email: data.userDetail.email,
        id: data.userDetails.id
      });
    }
  }, [data]);

  // ************************************************************************** Verification required Request OTP START *****************************F********************************************* 

  const handleRequestOtp = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/resendOtpOnRegisteredMobile/${userDetails.email}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }).then((response) => {
          handleRequestOtpOpen();
          console.log(response)
          handleMobileClose();
        })
    } catch (err) {
      console.log(err)
    }

  }

  // ************************************************************************** Verification required Request OTP END ************************************************************************** 
  // ************************************************************************** Verify with OTP  Verify START ************************************************************************** 
  const handleVerifyOtp = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/api/auth/verifyResendOtp/${userDetails.email}`,
        { resendVerifyOtp: otp },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );

      console.log(res);

      if (res.data.data.otpVerified === true) {
        handleVerifyMobileOpen();
        setOtp("");
        setApiSuccess(true); // Set the success state to true
        handleRequestClose();
      } else {
        console.log("otp is wrong try again");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ************************************************************************** Verify with OTP  Verify END ************************************************************************** 
    // ************************************************************************** Verify with OTP MOBILE  Verify START ************************************************************************** 
  // console.log(userDetailState.email);
  const handleUpdateRequestOtp = async (e) => {


    console.log("hello");
    console.log(userDetailState.email);

    try {
      const response = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/updatedPhoneNumber/${userDetailState.email}`,
        {
          updatedPhoneNumber: UpdatePhone
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }).then((response) => {

          console.log(response);
          if (response.status === 200) {

            // console.log("response " )
            // console.log(response);
            handleVerifyNewMobileOpen();
            //navigate to hte next modal to verify update number
          }
          else {
            console.log("Something went wrong in api calling")
          }
        })
    }
    catch (err) {
      console.log(err)
    }

  }
  // ************************************************************************** Verify with OTP MOBILE  Verify End ************************************************************************** 
  // ************************************************************************** Update mobile number SUBMIT START  ************************************************************************** 



  const handleUpdatedVerifyOtp = async () => {

    try {
      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/verifyOtpForUpdatedPhone/${userDetails.email}/${UpdatePhone}`,
        { verifyMobileOtp: otp },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      ).then((res) => {
        console.log(res);
        if (res.data.data.otpVerified === true) {
          handleVerifyNewMobileClose();
          handleVerifyMobileClose();
          handleVerifyClose();
          handleRequestClose();
          handleRequestEmailClose()
         
        const updatedDetails = { ...userDetails, phoneNumber: UpdatePhone }
          
   

    dispatch(setUserDetails({
       userDetails: updatedDetails 
      }));
         
      handleCloseParent();
          setOtp("");
       
        }
        else {
          console.log("otp is wrong try again")
        }
      })
    }
    catch (err) {
      console.log(err)
    }

  }
  // ************************************************************************** Update mobile number SUBMIT END ************************************************************************** 



  // ************************************************************************** Email Request OTP START ************************************************************************** 

  const handleRequestOtpEmail = async () => {
    // console.log("hello");
    // console.log(userDetailState.email);
    try {
      const response = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/requestEmailOtp?email=${businessData.email}`,

        {

          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }).then((response) => {
          console.log("Send OTP Email",response);
        })
    } catch (err) {
      console.log(err)
    }

  }

  // ************************************************************************** Email Request OTP END ****************************************************************** 
  // ************************************************************************** Email VERIFY OTP Start ****************************************************************** 


  const handleVerifyOtpEailVerify = async () => {
    // console.log("fuck Changes",email);
    try {
      const res = await axios.post(`${process.env.REACT_APP_STEELADMIN}/api/auth/verifyEmailOtp/${businessData.email}`,
        // console.log()                                                       
        { verifyEmailOtp: emailOtp },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      ).then((res) => {
        console.log(res);
        if (res.data.data.emailOtpVerified === true) {
          handleVerifyMobileOpen()
          setEmailOtp("");
          handleClose();
          const updatedDetails = { ...userDetails, email: businessData.email }
          dispatch(setUserDetails({
            userDetails: updatedDetails

          }))
        }
        else {
          console.log("otp is wrong try again")
        }
      })
    }
    catch (err) {
      console.log(err)
    }

  }
  // ************************************************************************** Email VERIFY OTP END ****************************************************************** 
  return (
    <div className={modalstyles.MyProfileMain}>

       {/* ********************************Verification equired Start************************************** */}
      <Box sx={style} className={modalstyles.firstModals} >
        <Typography variant='h3'>Verification required</Typography>
        <Typography variant='h4'>For better security, OTP is sent to a previously used number on your account.</Typography>
        <input
          label="number*"
          type='text'
          disabled
          value={businessData.phoneNumber}
          onChange={(e) => setBusinessData({ phoneNumber: e.target.value })}
          placeholder='number*'
          className={modalstyles.modalTextfield}
        />
        <Typography sx={{ fontWeight: '400', fontSize: '12px', lineHeight: '13px', color: '#94969F', mt: '2%' }}  >In case you dont have acess to this number please
          <Button sx={{ fontWeight: '400', fontSize: '12px', lineHeight: '13px', color: '#16469D', textTransform: 'capitalize' }} onClick={handleVerifyOpen}> <a style={{ borderBottom: '1px solid #16469D' }}>click here</a> </Button></Typography>

        <Button fullWidth sx={{
          padding: '15px 141px ',
          mt: '4%',
          textTransform: 'capitalize', display: 'flex', justifyContent: 'center', textAlign: 'center', bgcolorcolor: '#16469D', borderRadius: '2px',
          fontWeight: '600',
          fontSize: '14px',
          lineHeight: '16px'
        }} variant="contained" onClick={() => { handleRequestOtp(); }}>Request OTP</Button>

      
      </Box>
      {/* </Fade>
</Modal> */}
      {/* *************************Verification equired End************************************** */}

      {/* *************************Verify with OTP Start********************************** */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        sx={{ bgcolor: 'transparent', }}
        open={requestOtpOpen}
        onClose={handleRequestClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          style: { backgroundColor: 'rgba(0, 0, 0, 0.0)' } // You can customize the style of the backdrop here
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={requestOtpOpen}>
          <Box sx={style} className={modalstyles.thirdModal}>
            <Typography variant='h5'>Verify with OTP</Typography>

            <Typography variant='h6'> SMS Sent to  {businessData.phoneNumber}</Typography>


            
            <Box sx={{ mt: '4%' }} className={modalstyles.otpInput}>
              <input maxLength={5} type='otp' name='otp' value={otp} onChange={(e) => setOtp(e.target.value)} />
            </Box>

            {/* <MuiOtpInput className={modalstyles.forgotOTPInput}  style={{width:"100%"}} length={5} 
             value={otp} onChange={(e) => setOtp(e)} onKeyDown={handleKeyPress}/> */}
           
            <Button
              fullWidth
              sx={{

                width: '100%',
                padding: '12px 141px ',
                mt: '10%',
                textTransform: 'capitalize', display: 'flex', justifyContent: 'center', textAlign: 'center', bgcolorcolor: '#16469D', borderRadius: '2px',
                fontWeight: '600',
                fontSize: '14px',
                lineHeight: '16px'
              }} variant="contained"
              onClick={handleVerifyOtp}
            >Verify</Button>

          </Box>
        </Fade>
      </Modal>
      {/* *************************Verify with OTP End********************************** */}



      {/* *****************************************update mobile number Start******************************** */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={verifyMobileOpen}
        onClose={handleVerifyMobileClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          style: { backgroundColor: 'rgba(0, 0, 0, 0.0)' } // You can customize the style of the backdrop here
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={verifyMobileOpen} >
          <Box sx={style} className={modalstyles.firstModals}>
            <Typography variant='h3' sx={{ mt: '5%', mb: '10%' }}>Update mobile number</Typography>

            <input
              label="number*"
              type='text'
              placeholder='Enter Your new mobile number*'
              name="updateNumber"
              value={UpdatePhone}
              onChange={(e) => setUpdatePhone(e.target.value)}
              className={modalstyles.modalTextfield}
            />
            <Button fullWidth sx={{
              padding: '15px 141px ',
              mt: '10%',
              textTransform: 'capitalize', display: 'flex', justifyContent: 'center', textAlign: 'center', bgcolorcolor: '#16469D', borderRadius: '2px',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '16px'
            }} variant="contained" onClick={handleUpdateRequestOtp}>Submit</Button>
          </Box>
        </Fade>
      </Modal>

      {/* ******************************************update mobile number End******************************** */}
      {/* <Box className={modalstyles.MyProfileSecondMain} > */}

      {/* ******************************************Verify mobile start******************************** */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={verifyNewMobileOpen}
        onClose={handleVerifyNewMobileClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          style: { backgroundColor: 'rgba(0, 0, 0, 0.0)' } // You can customize the style of the backdrop here
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={verifyNewMobileOpen}>
          <Box sx={style1} className={modalstyles.thirdModal}>
            <Typography variant='h5'>Verify with OTP</Typography>
            <Typography variant='h6'> SMS Sent to {UpdatePhone}</Typography>

           
            <input style={{marginTop:'2%'}} type='number' name='otp' value={otp} onChange={(e) => setOtp(e.target.value)} />
            <Button
              fullWidth
              sx={{
                width: '334px',
                padding: '12px 141px ',
                mt: '4%',
                textTransform: 'capitalize', display: 'flex', justifyContent: 'center', textAlign: 'center', bgcolorcolor: '#16469D !important', borderRadius: '2px',
                fontWeight: '600',
                fontSize: '14px',
                lineHeight: '16px'
              }} variant="contained"
              onClick={handleUpdatedVerifyOtp}
            >Verify</Button>

          </Box>
        </Fade>
      </Modal>

      {/* ******************************************Verify mobile End******************************** */}
      {/* ****************************Verification required Email Start******************************* */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={verifyOpen}
        onClose={handleVerifyClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          style: { backgroundColor: 'rgba(0, 0, 0, 0.0)' } // You can customize the style of the backdrop here
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={verifyOpen}>
          <Box sx={style} className={modalstyles.firstModals}>
            <Typography variant='h3'>Verification required</Typography>
            <Typography variant='h4' sx={{ width: '70%' }}>For better security, OTP is sent to your registered email ID</Typography>
            <input
              label="number*"
              type='text'
              disabled
              value={businessData.email}

              onChange={(e) => setBusinessData({ email: e.target.value })}
              name='email'
              placeholder='email*'
              className={modalstyles.modalTextfield}

            />
            <Button fullWidth sx={{
              padding: '15px 141px ',
              mt: '5%',
              textTransform: 'capitalize', display: 'flex', justifyContent: 'center', textAlign: 'center', bgcolorcolor: '#16469D', borderRadius: '2px',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '16px'
            }} variant="contained" onClick={() => { handleRequestEmailOpen(); handleRequestOtpEmail() }}>Request OTP</Button>
          </Box>
        </Fade>
      </Modal>
      {/* ****************************Verification required Email End******************************* */}

      {/* ****************************Verify with OTP Email Start******************************* */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={requestEmailOpen}
        onClose={handleRequestEmailClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          style: { backgroundColor: 'rgba(0, 0, 0, 0.0)' } // You can customize the style of the backdrop here
        }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={requestEmailOpen}>
          <Box sx={style} className={modalstyles.thirdModal}>
            <Typography variant='h5'>Verify with OTP</Typography>
            <Typography variant='h6'>Sent to {businessData.email} </Typography>
          
            <MuiOtpInput className={modalstyles.forgotOTPInput}  style={{width:"100%"}} length={5} 
             value={emailOtp} onChange={(e) => setEmailOtp(e)} onKeyDown={handleKeyPress}/>
         

            <Button
              fullWidth
              sx={{
                // width: '334px',
                padding: '12px 141px ',
                mt: '4%',
                textTransform: 'capitalize',
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                bgcolorcolor: '#16469D !important',
                borderRadius: '2px',
                fontWeight: '600',
                fontSize: '14px',
                lineHeight: '16px',
                mb: '5%',
              }}
              variant="contained"
              // onClick={handleVerifyMobileOpen}
              onClick={handleVerifyOtpEailVerify}
            >
              Verify
            </Button>
          </Box>
        </Fade>
      </Modal>
      {/* ****************************Verify with OTP Email End******************************* */}
    </div>
  );
}

export default ModalComponent;
